import { DataBean } from "../DataBean";

export class LeftByValue extends DataBean {


    public async getBankingStatementMovementLeftByValue(idBankingStatement:any,conciliatedValue:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getBankingStatementMovementLeftByValue_Number_Number", [idBankingStatement,conciliatedValue]);
    }

}